<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="6" class="pr-0">
        <org-tree @switchOrg="handleSwitchOrg"></org-tree>
      </el-col>
      <el-col :span="18" class="mt-10">
        <el-row>
          <el-col :span="24">
            <el-card>
              <div slot="header" class="flex justify-between">
                <span>{{ $t('orgManage.queryCondition') }}</span>
              </div>
              <el-form :inline="true" :model="orgManageInfo.conditions" class="text-left">
                <el-form-item>
                  <el-input v-model.trim="orgManageInfo.conditions.staffName"
                    :placeholder="$t('orgManage.staffNamePlaceholder')" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="_queryOrgMethod">
                    <i class="el-icon-search"></i>
                    {{ $t('orgManage.query') }}
                  </el-button>
                </el-form-item>
              </el-form>
            </el-card>
          </el-col>
        </el-row>

        <el-card class="mt-10">
          <div slot="header" class="flex justify-between">
            <span v-if="orgManageInfo.orgName">
              {{ orgManageInfo.orgName }}{{ $t('orgManage.staff') }}
            </span>
            <span v-else>
              {{ $t('orgManage.relateStaff') }}
            </span>
            <div class="float-right">
              <el-button type="primary" size="small" @click="_openOrgRelStaff">
                <i class="el-icon-plus"></i>
                {{ $t('orgManage.relateStaff') }}
              </el-button>
            </div>
          </div>

          <el-table :data="orgManageInfo.staffs" border style="width: 100%">
            <el-table-column prop="name" :label="$t('orgManage.name')" align="center"></el-table-column>
            <el-table-column prop="tel" :label="$t('orgManage.phone')" align="center"></el-table-column>
            <el-table-column prop="relCdName" :label="$t('orgManage.position')" align="center"></el-table-column>
            <el-table-column prop="email" :label="$t('orgManage.email')" align="center"></el-table-column>
            <el-table-column prop="address" :label="$t('orgManage.address')" align="center"></el-table-column>
            <el-table-column prop="sex" :label="$t('orgManage.gender')" align="center">
              <template slot-scope="scope">
                {{ scope.row.sex == '0' ? $t('orgManage.male') : $t('orgManage.female') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('orgManage.operation')" align="center" width="180">
              <template slot-scope="scope">
                <el-button-group>
                  <!--v-if="hasPrivilege('502022082955220005') || hasPrivilege('502022092283880005')"-->
                  <el-button  size="mini"
                    @click="_openDeleteOrgRelStaff(scope.row)">
                    {{ $t('orgManage.delete') }}
                  </el-button>
                  <el-button size="mini" @click="_toStaffDetail(scope.row)">
                    {{ $t('orgManage.detail') }}
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-container">
            <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
              layout="total, prev, pager, next" :total="total"></el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <org-rel-staff ref="orgRelStaff" @notice="_listStaffs"></org-rel-staff>
    <delete-org-rel-staff ref="deleteOrgRelStaff" @notice="_listStaffs"></delete-org-rel-staff>
  </div>
</template>

<script>
import { getStaffList } from '@/api/frame/staffApi'
import OrgTree from '@/components/frame/orgTree/orgTree'
import OrgRelStaff from '@/components/frame/orgRelStaff/orgRelStaff'
import DeleteOrgRelStaff from '@/components/frame/deleteOrgRelStaff/deleteOrgRelStaff'

export default {
  name: 'OrgManage',
  components: {
    OrgTree,
    OrgRelStaff,
    DeleteOrgRelStaff
  },
  data() {
    return {
      orgManageInfo: {
        staffs: [],
        orgName: '',
        conditions: {
          orgId: '',
          staffName: ''
        }
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    handleSwitchOrg(params) {
      this.orgManageInfo.conditions.orgId = params.orgId
      this.orgManageInfo.orgName = params.orgName
      this._listStaffs()
    },
    _listStaffs() {
      if (!this.orgManageInfo.conditions.orgId) {
        this.orgManageInfo.staffs = []
        this.total = 0
        return
      }
      const params = {
        page: this.currentPage,
        row: this.pageSize,
        orgId: this.orgManageInfo.conditions.orgId,
        staffName: (this.orgManageInfo.conditions.staffName || '').trim()
      }

      getStaffList(params).then(response => {
        this.orgManageInfo.staffs = Array.isArray(response.data) ? response.data : []
        this.total = response.total != null ? response.total : this.orgManageInfo.staffs.length
      }).catch(error => {
        console.error('获取组织员工失败:', error)
        this.orgManageInfo.staffs = []
        this.total = 0
      })
    },
    _queryOrgMethod() {
      this.currentPage = 1
      this._listStaffs()
    },
    _openOrgRelStaff() {
      if (!this.orgManageInfo.conditions.orgId) {
        this.$message.warning(this.$t('orgManage.selectOrgFirst'))
        return
      }
      this.$refs.orgRelStaff.open({
        orgId: this.orgManageInfo.conditions.orgId
      })
    },
    _openDeleteOrgRelStaff(rel) {
      this.$refs.deleteOrgRelStaff.open(rel)
    },
    _toStaffDetail(staff) {
      this.$router.push(`/pages/frame/staffDetail?staffId=${staff.userId}`)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listStaffs()
    },
  }
}
</script>

<style scoped>
.pr-0 {
  padding-right: 0;
}

.mt-10 {
  margin-top: 10px;
}

.pagination-container {
  margin-top: 10px;
  text-align: right;
}

.float-right {
  float: right;
}
</style>